import React from 'react';
import classNames from 'classnames';
import Tooltip from '../components/base/Tooltip/Tooltip';
import {
  PARKING_METER_AVAILABLE_STATUS,
  PARKING_METER_STATUS, PARKING_SERVER_STATE,
} from '../modules/ParkingMeter/constants';
import { intlShape } from '../components/base/IntlProviderWrapper';
import { Icons } from '../components/base/BootstrapComponents';

export const statusNumberFormatter = (_, a) => {
  let status = 'error-status';
  if (a.available_status === PARKING_METER_AVAILABLE_STATUS.WARNING) { status = 'warning-status'; }
  if (a.available_status === PARKING_METER_AVAILABLE_STATUS.OK) { status = 'good-status'; }
  return (
    <div className={classNames('park-meter-status status-and-number', status)}>
      <div className="park-meter-status-color" />
      <div className="park-meter-status-text">{a.host}</div>
    </div>
  );
};
export const camStatusNumberFormatter = (_, a) => {
  let status = 'error-status';
  if (a.available_status === PARKING_METER_AVAILABLE_STATUS.WARNING) { status = 'warning-status'; }
  if (a.available_status === PARKING_METER_AVAILABLE_STATUS.OK) { status = 'good-status'; }
  return (
    <div className={classNames('park-meter-status status-and-number', status)}>
      <div className="park-meter-status-color" />
      <div className="park-meter-status-text">{a.name}</div>
    </div>
  );
};

export const statusNumberFormatterWithZone = (_, a) => (
  <div className="park-meter-status-with-zone">
    <Tooltip content={statusNumberFormatter(_, a)} className="pm-status-number-tooltip" />
    <div className="park-meter-status-zone">Зона {a.zbx_zone}</div>
  </div>
);

export const statusNameFormatterWithZone = (_, a) => (
  <div className="park-meter-status-with-zone">
    <Tooltip content={camStatusNumberFormatter(_, a)} className="cam-status-number-tooltip" />
    <div className="park-meter-status-zone">Зона {a.zbx_zone}</div>
  </div>
);

export const addressFormatter = (address, hideIcon = false, zbx_zone = null, isMobile = false, onClick = () => {}) => (
  <div className="address-formatter" onClick={onClick}>
    {!hideIcon && address ? <Icons customIcon icon="where-to-vote" className="pmh-icon where-to-vote" /> : null}
    <div className="address-formatter-text ">{address}</div>
    { isMobile && zbx_zone ? <div className="address-formatter-status-zone">Зона {zbx_zone}</div> : null}
  </div>
);

export const optionClassFormatter = item => {
  let status = item;
  if (typeof item === 'object') {
    status = item.value;
  }
  if (typeof item !== 'undefined') {
    if (+status === PARKING_METER_STATUS.OK) {
      return 'good-state';
    }
    if (+status === PARKING_METER_STATUS.WARNING) {
      return 'warning-state';
    }
    if (+status === PARKING_METER_STATUS.ERROR) {
      return 'error-state';
    }
  }
  return 'unknown-state';
};

export const dateFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  if (typeof a === 'string') {
    return a;
  }
  return formatDate(a, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};

export const timeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });
};

export const timeHMFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    hour: 'numeric',
    minute: 'numeric',
  });
};

export const dateTimeFormatter = a => {
  const {
    formatDate,
  } = intlShape;
  if (!a) {
    return '';
  }
  return formatDate(a, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).replace(',', ' ');
};
